import workspaceQuery from 'graphql/queries/customer/AccountStatusWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/customer/AccountStatusListQuery.graphql';
import instanceQuery from 'graphql/queries/customer/AccountStatusQuery.graphql';
import defaultQuery from 'graphql/queries/customer/AccountStatusDefault.graphql';
import mutationQuery from 'graphql/mutations/customer/AccountStatusMutation.graphql';
import fragment from 'graphql/fragments/customer/AccountStatusFragment.graphql';

const CustomerAccountStatus = {
  type: 'CustomerAccountStatus',
  title: 'Customer Account Status',
  formUrl: '/Customers/AccountStatus/Details/',
  formTitle: 'Customer Account Status',
  workspaceUrl: '/Customers/AccountStatus/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    remoteFilter: true,
    preLoad: true,
  },
  fragment,
  screenReference: 'CUSTOMER_ACCOUNT_STATUS',
};

export default CustomerAccountStatus;
